import { render, staticRenderFns } from "./coupon-approve.vue?vue&type=template&id=38d192ce&scoped=true&"
import script from "./coupon-approve.vue?vue&type=script&lang=js&"
export * from "./coupon-approve.vue?vue&type=script&lang=js&"
import style0 from "./coupon-approve.vue?vue&type=style&index=0&id=38d192ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d192ce",
  null
  
)

export default component.exports